import { render } from "./CrisisFooter.vue?vue&type=template&id=07199f80&scoped=true&ts=true&lang=pug"
import script from "./CrisisFooter.vue?vue&type=script&lang=ts"
export * from "./CrisisFooter.vue?vue&type=script&lang=ts"

import "./CrisisFooter.vue?vue&type=style&index=0&id=07199f80&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./CrisisFooter.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/common/crisisFooter.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fcomponents%2Fcommon%2FCrisisFooter.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07199f80"]])

export default __exports__